import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React, { useEffect, useRef, useCallback, useState } from "react"
import { connect } from "react-redux"

import api from "apis"
import { useIntersection } from "helpers/use-intersection"

export default function withMatchingProducts(WrappedComponent) {
  const InternalComponent = (props) => {
    const { styleCode } = props
    const ref = useRef()
    const inViewport = useIntersection(ref, "50px")
    const [matchingProducts, setMatchingProducts] = useState(null)
    const cancelled = useRef(false)

    const fetchAndSet = useCallback(async () => {
      if (!cancelled.current && styleCode) {
        try {
          const result = await api.get(
            `/api/v10/products/${styleCode}/recommended_items`
          )
          if (result?.data) {
            setMatchingProducts(result.data)
          } else {
            throw new Error("Error on fetch recommended_items")
          }
        } catch (error) {
          console.log(error)
        }
      }
    }, [styleCode])

    useEffect(() => {
      if (inViewport) {
        fetchAndSet()
      }
    }, [fetchAndSet, inViewport])

    useEffect(() => {
      return () => (cancelled.current = true)
    }, [])

    return (
      <Box ref={ref}>
        {matchingProducts && (
          <WrappedComponent
            {...props}
            pairsWell={matchingProducts?.pairs_well || []}
            recommended={matchingProducts?.recommended || []}
          />
        )}
      </Box>
    )
  }

  InternalComponent.propTypes = {
    styleCode: PropTypes.string,
  }

  const mapStateToProps = (state) => {
    return {
      styleCode:
        (state.choices.style_code && state.choices.style_code.value) ||
        state.wizard.description.style_code,
    }
  }

  const mapDispatchToProps = () => ({})

  const Component = connect(
    mapStateToProps,
    mapDispatchToProps
  )(InternalComponent)

  return Component
}
